import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Cookies = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h1 className="mb-4">Cookie Policy</h1>
          <p className="text-muted mb-5">
            Last updated: {new Date().getFullYear()}
          </p>

          <div className="mt-4">
            <h3>What Are Cookies?</h3>
            <p>
              Cookies are small text files that are stored on your device when
              you visit our website. They help us provide you with a better
              experience and improve our services.
            </p>
          </div>

          <div className="mt-4">
            <h3>How We Use Cookies</h3>
            <ul>
              <li>
                <strong>Essential Cookies:</strong> Required for basic website
                functionality and security
              </li>
              <li>
                <strong>Performance Cookies:</strong> Help us understand how
                visitors use our website
              </li>
              <li>
                <strong>Functional Cookies:</strong> Remember your preferences
                and settings
              </li>
              <li>
                <strong>Security Cookies:</strong> Protect against fraud and
                maintain security
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h3>Types of Cookies We Use</h3>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Cookie Type</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Session</td>
                    <td>Authentication and security</td>
                    <td>Session only</td>
                  </tr>
                  <tr>
                    <td>Persistent</td>
                    <td>User preferences</td>
                    <td>Up to 1 year</td>
                  </tr>
                  <tr>
                    <td>Analytics</td>
                    <td>Website performance</td>
                    <td>Up to 2 years</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-4">
            <h3>Managing Cookies</h3>
            <p>
              You can control and manage cookies through your browser settings.
              Please note that disabling certain cookies may affect website
              functionality.
            </p>
          </div>

          <div className="mt-5">
            <p className="text-muted">
              For questions about our cookie policy, contact
              privacy@airclift.com
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Cookies;
